import React from 'react';

interface SimilarityBadgeProps {
  score: number;
}

export function SimilarityBadge({ score }: SimilarityBadgeProps) {
  return (
    <span className="px-2.5 py-1 text-sm font-medium rounded-full bg-blue-100 text-blue-800">
      {(score * 100).toFixed(2)}% Match
    </span>
  );
}